import { ArcElement, Chart as ChartJS, Legend, Tooltip } from "chart.js";
import ChartDataLabels from "chartjs-plugin-datalabels";
import { Col, Row } from "react-bootstrap";
import { Doughnut } from "react-chartjs-2";
import { ChartLabel } from "../../interfaces/chart-label";
import DoughnutChartLabel from "../doughnut-chart-label/doughnut-chart-label";

ChartJS.register(ArcElement, Tooltip, Legend, ChartDataLabels);

interface IProps {
  labels?: string[];
  dataset: number[];
  labelComponents?: ChartLabel[];
  backgroundColors?: string[];
  borderColors?: string[];
  formatValue?: (value: number) => string;
  formatLabel?: (tooltipItem: any) => string;
  isDisplayLabels?: boolean;
  chartHeight?: number;
  chartWidth?: number;
}

const fontWeight: "bold" | "normal" | "bolder" | "lighter" | undefined = "bold";

const DoughnutChart = (props: IProps) => {
  const {
    labels = [],
    labelComponents = [],
    backgroundColors = [],
    borderColors = [],
    dataset,
    formatValue,
    formatLabel,
  } = props;

  const isEmpty = dataset.every((val) => val === 0);
  const defaultEmptyColor = "#EDF0F3";

  const options = {
    responsive: true,
    maintainAspectRatio: true,
    cutout: "65%",
    animation: {
      duration: 2500,
      easing: "easeOutCubic" as const,
    },
    plugins: {
      datalabels: {
        display: props.isDisplayLabels,
        color: "#fff",
        font: {
          size: 14,
          weight: fontWeight,
        },
        formatter: formatValue,
      },
      tooltip: isEmpty
        ? { enabled: false }
        : {
            callbacks: {
              label: formatLabel,
            },
          },
      centerText: false,
      responsive: true,
    },
  };

  const data = {
    labels,
    datasets: [
      {
        data: isEmpty ? [1] : dataset,
        borderWidth: 1,
        backgroundColor: isEmpty ? defaultEmptyColor : backgroundColors,
        borderColor: isEmpty ? defaultEmptyColor : borderColors,
      },
    ],
  };

  return (
    <Row className="align-items-center">
      {labelComponents.length > 0 && (
        <Col className="col-auto">
          {labelComponents.map((labelComponent, index) => {
            return (
              <DoughnutChartLabel
                key={index}
                label={labelComponent.label}
                icon={labelComponent.icon}
                iconColor={labelComponent.iconColor}
                labelBackgroundColor={labelComponent.labelBackgroundColor}
              />
            );
          })}
        </Col>
      )}
      <Col>
        <Row className="justify-content-center">
          <Col className="col-auto">
            <Doughnut
              data={data}
              options={options}
              style={{
                width: props.chartWidth ? `${props.chartWidth}px` : "230px",
                height: props.chartHeight ? `${props.chartHeight}px` : "230px",
              }}
            />
          </Col>
        </Row>
      </Col>
    </Row>
  );
};

export default DoughnutChart;
